// extracted by mini-css-extract-plugin
module.exports = {"panel":"GroupFormPanel_panel__fTJ6n","fields":"GroupFormPanel_fields__h3z0Q","footer":"GroupFormPanel_footer__5PLDC","error":"GroupFormPanel_error__HLx8p"};